$(function() {
  function formatCurrencies(currencyTable) {
    for (isoCode in currencyTable) {
      currencyTable[isoCode] = I18n.format_amount_in_currency(currencyTable[isoCode], isoCode, null, { prependCurrencySymbol: true });
    }

    return currencyTable;
  }

  var $container = $('.js-recommended-lots');
  if (!$container.length) {
    return;
  }

  var template = tmpl(document.getElementById('tmpl-recommended-lot').innerHTML);

  $.ajax('/buyer/api/v1/users/me/lots/recommendations', {
    data: { per_page: 4, fallback: true },
    cache: false,
    crossDomain: true,
    xhrFields: {
      withCredentials: true
    }
  }).then(function(response) {
    var lots = response.lots;
    $container.removeClass('cw-spinner cw-spinner-on');

    // Happy path
    if (lots && lots.length) {
      var html = lots.map(function(lot) {
        lot.current_bid_amount = formatCurrencies(lot.current_bid_amount);
        return template(lot);
      }).join('');

      $container.html(html);
      $container.find('h2').sameHeight();
      $container.blockLinks();
      $container.find('.cw-ab_click').on('click.ab-click-conversion', function() {
        var goal = $(this).data('ab-conversion');
        if (goal) {
          AB.conversion(goal);
        }
      });

    // No results. Since we have a fallback this should never happen, but let's
    // handle the case
    } else {
      AB.conversion('pr_zrp_recommended_lots_empty_response');
      $container.closest('.cw-recommended-lots').remove();
    }
  }).fail(function() {
    AB.conversion('pr_zrp_recommended_lots_error_response');
    $container.closest('.cw-recommended-lots').remove();
  });
});
